<div
  class="flex justify-content-around flex-wrap h-screen align-content-center">
  <div class="flex flex-column align-items-center -mt-8">
    <app-logo hStyleClass="h-12rem w-18rem" />
    <app-login-form [redirect]="true"></app-login-form>
  </div>
</div>
<app-footer />
